export default "__VITE_ASSET__CMgI6XVN__"